export default{
    InvoicTitle:{
        Headers:{
            title:"You have added",
            title1:"invoice information entries, can still add",
            title2:"more",
        },
        form:{
            query:"Order Number",
            invoApplyStatus:"Invoice Status",
            datepicker:"Application Date",
            defaultFlag:"Default Title",
            defaultFlag1:"Set as Default",
        },
        placeholder:{
            query:"Enter order number",
            invoApplyStatus:"All",
            datepicker:["Start date","End date"],
        },
        Message:{
               type:"Notification",
               content:"Delete this invoice information?",
               success:"Invoice deleted successfully!",
               success1:"Set as default successfully!",
               info:"Cancelled",
               warning:"Cannot add invoice. Please delete existing entries first"
        },
        Alert:{
        },
        Button:{
            addInvo:'Add Invoice',
            btnRevise:"Edit",
            btnDelete:"Delete",
            confirmButtonText:"Confirm",
            cancelButtonText: "Cancel",
        },
        Placeholder:{
        },
        Validate:{
        },
        Description:{
            noData:'No invoices available',
            emptyText:"No data"
        },
        Table:{
            headerName:['Invoice Title','Type','Content','Invoice Type','Unified Social Credit Code','Recipient Name','Contact Number','Shipping Address','Action'],
        }
    }
}